<template>

    <ion-row>
        <ion-col size="12" size-md="10" offset-md="1" size-lg="10" offset-lg="1" size-xl="8" offset-xl="2">
            <div class="padding">
                <div class="text-center">
                    <h1 class="h1 text-center">Aktualności</h1>
                </div>
            </div>

            <div v-if="loading" class="loader-wrapper"><span class="loader red"></span></div>
            <transition name="long-fade">
                <div class="padding">
                    <item-news
                            v-for="item in newsCollection"
                            :key="item.id"
                            :routeName="'NewsSingle'"
                            :slug="item.slug"
                            :title="item.title"
                            :thumbnail="item.thumbnail"
                            :excerpt="item.excerpt"
                            :date="item.createdAtDate"
                            :time="item.createdAtTime">
                    </item-news>
                </div>
            </transition>
            <ion-row v-if="loading === false && newsCollection.length === 0">
                <ion-col size="12">
                    <p class="text-center">Brak danych</p>
                </ion-col>
            </ion-row>
        </ion-col>
    </ion-row>

</template>

<script>
    import ItemNews from '../../../items/ItemNews'
    import NewsServices from "../../../services/NewsServices";

    export default {
        name: 'NewsList',
        components: {ItemNews},
        data() {
            return {
                loading: true,
                errors: [],
                newsCollection: []
            }
        },
        methods: {
            getData() {
                this.loading = true;
                NewsServices.getNews()
                    .then((response) => {
                        this.newsCollection = response.data.data;
                        this.loading = false;
                    })
                    .catch((e) => {
                        this.errors.push(e.toString())
                    })
            }
        },
        mounted() {
            this.getData();
        }
    }
</script>